// extracted by mini-css-extract-plugin
module.exports = {"container":"x7_e"};